<template>
  <div class="alert-body formulario">
     <h1 class="alert-title">Resposta do fornecedor</h1>

      <div class="row">
        <div class="form-group border-blocos validacao_status_notificacao_id">
          <label class="col-xs-12 col-sm-4 col-md-4">Você concorda com a notificação apresentada?<i class="text-danger">*</i></label>
          <div class="input-group col-xs-12 col-sm-8 col-md-8">
            <div class="row">
              <div class="col-xs-12 col-sm-4 col-md-4 option-first">
                      <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="2" v-model="formExibirNotificacoes.status_notificacao_id.valor">
                      <label class="form-check-label" for="inlineRadio1">Concordo</label>
              </div>
              <div class="col-xs-12 col-sm-4 col-md-4 option-first">
                      <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="3" v-model="formExibirNotificacoes.status_notificacao_id.valor">
                      <label class="form-check-label" for="inlineRadio2">Nao Concordo</label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="form-group border-blocos validacao_observacao_fornecedor">
            <label class="col-xs-12 col-sm-4 col-md-4">Justifique<i class="text-danger">*</i></label>
            <div class="input-group col-xs-12 col-sm-8 col-md-8">
                <div class="row">
                    <div class="col-xs-12 col-sm-8 col-md-8 option-first">
                        <textarea
                          v-model="formExibirNotificacoes.observacao_fornecedor.valor"
                          :placeholder="formExibirNotificacoes.observacao_fornecedor.placeholder"
                          class="form-control" rows="3" 
                        ></textarea>
                    </div>
                </div>
            </div>
        </div>
      </div>

      <!-- <div class="row">
        <div class="form-group border-blocos validacao_observacao_fornecedor">
            <label class="col-xs-12 col-sm-4 col-md-4">Insira seu email<i class="text-danger">*</i></label>
            <div class="input-group col-xs-12 col-sm-8 col-md-8">
                <div class="row">
                    <div class="col-xs-12 col-sm-8 col-md-8 option-first">
                        <input
                          type="text"
                          v-model="formExibirNotificacoes.email.valor"
                          :placeholder="formExibirNotificacoes.email.placeholder"
                          class="form-control"
                        >
                        </input>
                    </div>
                </div>
            </div>
        </div>
      </div> -->

      <button
        @click="enviarFormulario()"
        type="button" class="btn btn-primary pull-right" data-dismiss="modal"
        v-if="controlerBtnSubmit">Salvar
      </button>
      <button type="button" class="btn btn-primary btn-submit" disabled v-else><i class='fa fa-refresh fa-spin'></i> aguarde...</button>
  </div>
</template>

<script>
export default {
  data () {
    return {
      formExibirNotificacoes: {
        notificacao_id: {nome: 'notificacao_id', valor: null},
        status_notificacao_id: {nome: 'status_notificacao_id', valor: null},
        observacao_fornecedor: {nome: 'observacao_fornecedor', placeholder: 'Inserir justificativa', valor: null},
        uf_id: {nome: 'uf_id', valor: null},
        tipo_imovel_servico_id: {nome: 'tipo_imovel_servico_id', valor: null},
        hash: {nome: 'hash', valor: null},
        email: {nome: 'email', placeholder: 'Insira o email onde você foi notificado', valor: null}
      },
      usuario: '',
      controlerBtnSubmit: true,
      env: process.env
    }
  },
  mounted: function () {
    this.formExibirNotificacoes.hash.valor = this.$route.params.hash
    this.verificaHash()
    this.getDadosFormulario()
  },
  methods: {
    verificaHash () {
      let vm = this
      this.$axios.post(`${this.env.FINANCEIRO.NOTIFICACAO}/verificarHashFormSemLogar`, this.formExibirNotificacoes['hash']
      ).then(function (response) {
        if (response.data) {
          return response.data
        } else if (response.data === false) {
          vm.$store.commit('setAlert', {msg: `Esse link perdeu a validade!`, status: false, show: true})
          setTimeout(function () {
            vm.$router.push('/Login')
          }, 3500)
        }
      }).catch(error => {
        console.log(error)
        vm.$store.commit('setAlert', {msg: error.response.data.erro, status: false, show: true})
        setTimeout(function () {
          vm.$router.push('/Login')
        }, 3500)
        vm.controlerBtnSubmit = true
      })
    },
    getDadosFormulario () {
      let vm = this
      let hash = this.formExibirNotificacoes['hash'].valor
      this.$axios.get(`${this.env.FINANCEIRO.NOTIFICACAO}/getDadosFormularioRespostaNotificacaoDeslogado/${hash}`
      ).then(function (response) {
        if (response.data) {
          vm.formExibirNotificacoes.uf_id.valor = response.data.uf_id
          vm.formExibirNotificacoes.tipo_imovel_servico_id.valor = response.data.tipo_imovel_servico_id
          vm.formExibirNotificacoes.notificacao_id.valor = response.data.id
          vm.formExibirNotificacoes.email.valor = response.data.email_fornecedor_resposta
        } else if (response.data === false) {
          vm.$store.commit('setAlert', {msg: `Esse link perdeu a validade!`, status: false, show: true})
          setTimeout(function () {
            vm.$router.push('/Login')
          }, 3500)
        }
      }).catch(error => {
        console.log(error)
        vm.$store.commit('setAlert', {msg: error.response.data.erro, status: false, show: true})
        setTimeout(function () {
          vm.$router.push('/Login')
        }, 3500)
        vm.controlerBtnSubmit = true
      })
    },
    enviarFormulario () {
      let vm = this
      this.controlerBtnSubmit = false
      this.$axios.post(`${this.env.FINANCEIRO.NOTIFICACAO}/salvarRespostaFornecedorSemLogin`, this.preencherFormData()
      ).then(function (response) {
        if (response.status === 200 || response.status === 201) {
          vm.$store.commit('setAlert', {msg: 'Resposta salva com sucesso.', status: true, show: true})
          setTimeout(function () {
            vm.$router.push('/Login')
          }, 3500)
        } else {
          vm.$store.commit('setAlert', {msg: 'Resposta não foi salva.', status: false, show: true})
        }
        vm.limparDadosFormulario()
        vm.controlerBtnSubmit = true
      }).catch(error => {
        if (error.response.status === 422) {
          vm.controlerBtnSubmit = true
          vm.$store.commit('setAlert', {msg: 'Preencha todos os campos corretamente!', status: false, show: true})
        } else {
          vm.controlerBtnSubmit = true
          vm.$store.commit('setAlert', {msg: 'Algo deu errado! Tente novamente mais tarde tarde.', status: false, show: true})
        }
        vm.controlerBtnSubmit = true
      })
    },
    preencherFormData () {
      let formData = new FormData()
      formData.append('notificacao_id', this.formExibirNotificacoes.notificacao_id.valor)
      formData.append('status_notificacao_id', this.formExibirNotificacoes.status_notificacao_id.valor)
      formData.append('observacao_fornecedor', this.formExibirNotificacoes.observacao_fornecedor.valor)
      formData.append('uf_selecionada', this.formExibirNotificacoes.uf_id.valor)
      formData.append('tipo_imovel_servico', this.formExibirNotificacoes.tipo_imovel_servico_id.valor)
      formData.append('email', this.formExibirNotificacoes.email.valor)
      return formData
    },
    limparDadosFormulario () {
      this.formExibirNotificacoes.status_notificacao_id.valor = ''
      this.formExibirNotificacoes.observacao_fornecedor.valor = ''
      this.formExibirNotificacoes.email.valor
    }
  }
}
</script>
<style scoped src="../css/formExibirNotificacaoSemLogin.css"></style>



// WEBPACK FOOTER //
// FormExibirNotificacaoSemLogin.vue?0a4cac90